module.exports = __webpack_public_path__ + "static/media/036-central-african-republic.c4f47711.svg";